import React, {
  useContext,
  useEffect,
  useReducer,
  useRef,
  useState,
} from "react";
import { Tab, Tabs } from "react-bootstrap";
import Button from "react-bootstrap/esm/Button";
import Col from "react-bootstrap/esm/Col";
import Row from "react-bootstrap/esm/Row";
import { Helmet } from "react-helmet-async";
import {
  FaBox,
  FaChartBar,
  FaClipboardList,
  FaMoneyBillWave,
  FaWarehouse,
} from "react-icons/fa";
import { useMediaQuery } from "react-responsive";
import { useLocation } from "react-router-dom";
import { toast } from "react-toastify";
import { Store } from "../Store";
import AnalyticRaportAdetlerVeTutarlar from "../components/AnalyticRaportAdetlerVeTutarlar";
import LoadingBox from "../components/LoadingBox";
import MessageBox from "../components/MessageBox";
import OrdersTableList from "../components/OrdersTableList";
import StockTable from "../components/StockTable";
import useAxios from "../hooks/useAxios";
import {
  applyPreviuosMonthStock,
  getError,
  getMonthlyStocksReFormatted,
  turkishCurrencyFormatterNoPrecision,
} from "../utils";
import DailyReportScreenSave from "./DailyReportScreenSave";
import ExpenseListScreen from "./ExpenseListScreen";

const reducer = (state, action) => {
  switch (action.type) {
    case "FETCH_REQUEST":
      return { ...state, loading: true };
    case "FETCH_SUCCESS":
      return {
        ...state,
        loading: false,
      };
    case "FETCH_FAIL":
      return { ...state, loading: false };
    case "DELETE_REQUEST":
      return { ...state, deleteInProgress: true };
    case "DELETE_SUCCESS":
      return {
        ...state,
        deleteInProgress: false,
      };
    case "DELETE_FAIL":
      return { ...state, deleteInProgress: false };

    default:
      return state;
  }
};

export default function DailyReportScreen() {
  const axios = useAxios();
  const descriptionRef = useRef(null);
  const [activeTab, setActiveTab] = useState("ozet");
  const [selectedProduct, setSelectedProduct] = useState({ product: "" });
  const [selectedProductGift, setSelectedProductGift] = useState({
    product: "",
  });
  const [showDailySaveModal, setShowDailySaveModal] = useState(false);
  const [{ loading, error, categories, products, deleteInProgress }, dispatch] =
    useReducer(reducer, {
      loading: true,
      error: "",
      deleteInProgress: false,
      categories: [],
      products: [],
    });

  const { state, dispatch: ctxDispatch } = useContext(Store);
  const { userInfo, carts, table, categoryHistory, mostUsedProducts } = state;
  const isTabletOrMobile = useMediaQuery({ query: "(max-width: 1224px)" });
  const [dailyReport, setDailyReport] = useState();
  const [allReports, setAllReports] = useState([]);
  const [netStockAmount, setNetStockAmount] = useState();
  const [previousDayStock, setPreviousDayStock] = useState({
    netStocks: [],
  });

  const [reportDate, setReportDate] = useState();
  //const [waitNextDay, setWaitNextDay] = useState(false);
  const [reportDanger, setReportDanger] = useState(false);
  const [lastLineNum, setLastLineNum] = useState();
  const [isUpdate, setIsUpdate] = useState(false);

  const { search } = useLocation();
  const sp = new URLSearchParams(search);
  const reportdateFromSummary = sp.get("reportDate");

  const deleteDailyHandler = async () => {
    try {
      dispatch({ type: "DELETE_REQUEST" });

      if (!dailyReport.isLastDaily) {
        toast.error("Bu gün sonu silinemez!");
        return;
      }

      await axios.delete(`/api/orders/dailyreport/${dailyReport._id}`);

      fetchDailyReport();

      dispatch({ type: "DELETE_SUCCESS" });
      toast("Günsonu raporu başarılı bir şekilde silindi!");
    } catch (err) {
      dispatch({ type: "DELETE_FAIL" });
      toast.error(getError(err));
    }
  };

  const fetchDailyReport = async () => {
    try {
      dispatch({ type: "FETCH_REQUEST" });
      const { data: reportDateData } = await axios.get(
        `/api/orders/reportdate`
      );

      setReportDate(new Date(reportDateData.reportDate));
      setReportDanger(reportDateData.reportDanger);
      setLastLineNum(reportDateData.lastLineNum);

      const { data } = await axios.get(
        `/api/orders/dailyreport?reportDate=${reportDateData.reportDate}&expenseDate=${reportDateData.expenseDate}&lastLineNum=${reportDateData.lastLineNum}`
      );
      setDailyReport(data.dailyReport);
      setAllReports(data.allReports);

      const { data: dailyReportDataPrevious } = await axios.get(
        `/api/orders/dailyreportbymaxlinenum?startLineNum=${data.dailyReport?.startLineNum}`
      );
      setPreviousDayStock(
        dailyReportDataPrevious.dailyReport || { netStocks: [] }
      );

      dispatch({ type: "FETCH_SUCCESS" });
    } catch (err) {
      dispatch({ type: "FETCH_FAIL" });
      toast(getError(err));
    }
  };

  const fetchDailyReportAgainToUpdate = async () => {
    try {
      dispatch({ type: "FETCH_REQUEST" });

      setReportDate(new Date(dailyReport.startedAt));
      setReportDanger(false);
      setLastLineNum(dailyReport.lastLineNum);
      setIsUpdate(true);

      const { data } = await axios.get(
        `/api/orders/dailyreport?reportDate=${dailyReport.finishedAt}&expenseDate=${dailyReport.startedAt}&lastLineNum=${dailyReport.startLineNum}&lastLineNum2=${dailyReport.endLineNum}`
      );

      setDailyReport(data.dailyReport);
      setAllReports(data.allReports);

      const { data: dailyReportDataPrevious } = await axios.get(
        `/api/orders/dailyreportbymaxlinenum?startLineNum=${data.dailyReport?.startLineNum}`
      );
      setPreviousDayStock(
        dailyReportDataPrevious.dailyReport || { netStocks: [] }
      );

      dispatch({ type: "FETCH_SUCCESS" });
    } catch (err) {
      dispatch({ type: "FETCH_FAIL" });
      toast(getError(err));
    }
  };

  useEffect(() => {
    if (!reportdateFromSummary) {
      fetchDailyReport();
    }
  }, [reportdateFromSummary]);

  const fetchDailyReportByDate = async (querydate) => {
    try {
      dispatch({ type: "FETCH_REQUEST" });
      const { data: dailyReportData } = await axios.get(
        `/api/orders/dailyreportbydate?startedAt=${querydate.toISOString()}`
      );

      if (dailyReportData.dailyReport) {
        setReportDate(new Date(dailyReportData.dailyReport.startedAt));
      }
      setReportDanger(false);
      setAllReports(dailyReportData.allReports);
      setDailyReport(dailyReportData.dailyReport);

      const previousDay = querydate
        ? new Date(querydate.getTime())
        : new Date();
      previousDay.setDate(previousDay.getDate() - 1);
      const { data: dailyReportDataPrevious } = await axios.get(
        `/api/orders/dailyreportbymaxlinenum?startLineNum=${dailyReportData.dailyReport?.startLineNum}`
      );
      setPreviousDayStock(
        dailyReportDataPrevious.dailyReport || { netStocks: [] }
      );

      dispatch({ type: "FETCH_SUCCESS" });
    } catch (err) {
      dispatch({ type: "FETCH_FAIL" });
      toast(getError(err));
    }
  };

  useEffect(() => {
    if (reportdateFromSummary) {
      fetchDailyReportByDate(new Date(reportdateFromSummary));
    }
  }, [reportdateFromSummary]);

  return (
    <div>
      <Helmet>
        <title>Gün Sonu</title>
      </Helmet>

      <div className="row">
        <div
          className="col-md-6 mb-3"
          style={{
            display: "flex",
            flexDirection: "row",
            flexWrap: "wrap",
            justifyContent: "space-between",
          }}
        >
          <div className="ms-auto">
            {dailyReport && dailyReport._id && dailyReport.isLastDaily && (
              <Row>
                <Col className="d-grid ">
                  <Button
                    type="button"
                    variant="danger"
                    onClick={() => {
                      deleteDailyHandler();
                    }}
                  >
                    {isTabletOrMobile ? "Gün Sonu Sil" : "Gün Sonu Sil"}
                  </Button>
                </Col>
              </Row>
            )}
          </div>

          {dailyReport && allReports && allReports.length > 1 && (
            <div>
              {allReports.map((r, index) => (
                <Button
                  key={index}
                  variant={
                    dailyReport.startLineNum === r.startLineNum
                      ? "primary"
                      : "outline-primary"
                  }
                  className="m-1"
                  onClick={() => setDailyReport(r)}
                >
                  {index + 1}
                  {!isTabletOrMobile ? ". Kapanış" : ". K"}
                </Button>
              ))}
            </div>
          )}
          {dailyReport &&
            dailyReport._id &&
            !dailyReport?.update &&
            userInfo.isHelpDesk && (
              <Button
                variant="outline-primary"
                onClick={() => fetchDailyReportAgainToUpdate()}
              >
                {"Yeniden Oluştur"}
              </Button>
            )}
        </div>
      </div>

      <Tabs
        activeKey={activeTab}
        onSelect={(k) => setActiveTab(k)}
        className="mb-3"
      >
        <Tab
          eventKey="ozet"
          title={
            <>
              <FaClipboardList /> Özet
            </>
          }
        >
          <div className="row">
            <div className="col-md-6">
              {loading || deleteInProgress ? (
                <LoadingBox></LoadingBox>
              ) : (
                <>
                  {dailyReport ? (
                    <>
                      <table className="table">
                        <tbody>
                          <tr className="table-primary">
                            <td className="text-bold">Gün</td>
                            <td>
                              {reportDate.toLocaleDateString("tr-TR", {
                                weekday: "long",
                                year: "numeric",
                                month: "long",
                                day: "numeric",
                              })}
                            </td>
                          </tr>
                          <tr className="table-primary">
                            <td className="text-bold">Açılış</td>
                            <td>
                              {new Date(dailyReport.startedAt)
                                .toLocaleString("tr-TR")
                                .substring(0, 16)}
                              &nbsp;
                              <span className="small-font text-muted">
                                No: {dailyReport.startLineNum}
                              </span>
                            </td>
                          </tr>
                          <tr className="table-primary">
                            <td className="text-bold">Kapanış</td>
                            <td>
                              {dailyReport.finishedAt
                                ? new Date(dailyReport.finishedAt)
                                    .toLocaleString("tr-TR")
                                    .substring(0, 16)
                                : new Date()
                                    .toLocaleString("tr-TR")
                                    .substring(0, 16)}
                              &nbsp;
                              <span className="small-font text-muted">
                                No: {dailyReport.endLineNum}
                              </span>
                            </td>
                          </tr>
                          {dailyReport._id && (
                            <>
                              {!!dailyReport.excessCache && (
                                <tr className="table-primary">
                                  <td className="text-bold">
                                    Eksik Çıkan Nakit
                                  </td>
                                  <td>
                                    {turkishCurrencyFormatterNoPrecision(
                                      dailyReport.excessCache
                                    )}
                                  </td>
                                </tr>
                              )}
                              {!!dailyReport.missingCache && (
                                <tr className="table-primary">
                                  <td className="text-bold">
                                    Fazla Çıkan Nakit
                                  </td>
                                  <td>
                                    {turkishCurrencyFormatterNoPrecision(
                                      dailyReport.missingCache
                                    )}
                                  </td>
                                </tr>
                              )}
                              {!!dailyReport.forwardCache && (
                                <tr className="table-primary">
                                  <td className="text-bold">
                                    Kasadan Devreden Nakit
                                  </td>
                                  <td>
                                    {turkishCurrencyFormatterNoPrecision(
                                      dailyReport.forwardCache
                                    )}
                                  </td>
                                </tr>
                              )}
                              {!!dailyReport.description && (
                                <tr className="table-primary">
                                  <td className="text-bold">Açıklama</td>
                                  <td>{dailyReport.description}</td>
                                </tr>
                              )}
                            </>
                          )}
                        </tbody>
                      </table>

                      <table className="table table-bordered">
                        <thead>
                          <tr className="table-warning">
                            <th></th>
                            <th className="text-end">Ciro</th>
                            <th className="text-end">Harcama</th>
                            <th className="text-end">Net</th>
                          </tr>
                        </thead>
                        <tbody>
                          <tr className="table-warning">
                            <td className="text-bold">POS</td>
                            <td className="text-end">
                              {turkishCurrencyFormatterNoPrecision(
                                dailyReport.totalPos
                              )}
                            </td>
                            <td className="text-end">
                              {turkishCurrencyFormatterNoPrecision(
                                dailyReport.totalExpensePos
                              )}
                            </td>
                            <td className="text-end">
                              {turkishCurrencyFormatterNoPrecision(
                                dailyReport.totalPos -
                                  dailyReport.totalExpensePos
                              )}
                            </td>
                          </tr>
                          <tr className="table-warning">
                            <td className="text-bold">Nakit</td>
                            <td className="text-end">
                              {turkishCurrencyFormatterNoPrecision(
                                dailyReport.totalCache
                              )}
                            </td>
                            <td className="text-end">
                              {turkishCurrencyFormatterNoPrecision(
                                dailyReport.totalExpenseCache
                              )}
                            </td>
                            <td className="text-end text-danger text-bold">
                              {turkishCurrencyFormatterNoPrecision(
                                dailyReport.totalCache -
                                  dailyReport.totalExpenseCache
                              )}
                            </td>
                          </tr>
                        </tbody>
                        <tfoot>
                          <tr className="table-warning">
                            <td className="text-bold">Toplam</td>
                            <td className="text-end">
                              {turkishCurrencyFormatterNoPrecision(
                                dailyReport.totalCache + dailyReport.totalPos
                              )}
                            </td>
                            <td className="text-end">
                              {turkishCurrencyFormatterNoPrecision(
                                dailyReport.totalExpenseCache +
                                  dailyReport.totalExpensePos
                              )}
                            </td>
                            <td className="text-end">
                              {turkishCurrencyFormatterNoPrecision(
                                dailyReport.totalCache +
                                  dailyReport.totalPos -
                                  (dailyReport.totalExpenseCache +
                                    dailyReport.totalExpensePos)
                              )}
                            </td>
                          </tr>
                        </tfoot>
                      </table>

                      {!dailyReport._id && (
                        <div className="d-grid mb-5">
                          <Button
                            size="lg"
                            type="button"
                            disabled={!dailyReport.startLineNum}
                            variant="light"
                            className={
                              dailyReport.startLineNum
                                ? "border-primary text-primary"
                                : "border-secondary text-secondary"
                            }
                            onClick={() => setShowDailySaveModal(true)}
                          >
                            {"Gün Sonu Gerçekleştir"}
                            &nbsp;
                            <i className="fas fa-angle-double-right"></i>
                          </Button>
                        </div>
                      )}
                    </>
                  ) : (
                    <MessageBox variant="danger">
                      Bu tarihte gün sonu işlemi yapılmamış!
                    </MessageBox>
                  )}
                </>
              )}
            </div>
          </div>
        </Tab>

        <Tab
          eventKey="tables"
          title={
            <>
              <FaBox /> Siparişler
            </>
          }
        >
          {activeTab === "tables" &&
            dailyReport &&
            dailyReport.startLineNum && (
              <OrdersTableList
                startLineNum={dailyReport.startLineNum}
                endLineNum={dailyReport.endLineNum}
              />
            )}
        </Tab>

        <Tab
          eventKey="details"
          title={
            <>
              <FaChartBar /> Kalemler
            </>
          }
        >
          <div className="row">
            <div className="col-md-9">
              {dailyReport && (
                <AnalyticRaportAdetlerVeTutarlar
                  dailyReport={dailyReport}
                  selectedProduct={selectedProduct}
                  setSelectedProduct={setSelectedProduct}
                  selectedProductGift={selectedProductGift}
                  setSelectedProductGift={setSelectedProductGift}
                />
              )}
            </div>
          </div>
        </Tab>
        <Tab
          eventKey="expenses"
          title={
            <>
              <FaMoneyBillWave /> Harcamalar
            </>
          }
        >
          {dailyReport && !loading && !deleteInProgress && (
            <ExpenseListScreen
              queryStartDate={dailyReport.startedAt}
              queryEndDate={dailyReport.finishedAt || new Date()}
              forReport={true}
              pageSize={6}
              tarihAsc={false}
            ></ExpenseListScreen>
          )}
        </Tab>
        <Tab
          eventKey="stocks"
          title={
            <>
              <FaWarehouse /> Stoklar
            </>
          }
        >
          <div className="row">
            <div className="col-md-6">
              {dailyReport &&
                dailyReport.netStocks?.length > 0 &&
                !loading &&
                !deleteInProgress && (
                  <StockTable
                    type="daily"
                    reportDate={reportDate}
                    netStockAmount={netStockAmount}
                    setNetStockAmount={setNetStockAmount}
                    stocks={applyPreviuosMonthStock(
                      getMonthlyStocksReFormatted(dailyReport.netStocks || []),
                      getMonthlyStocksReFormatted(
                        previousDayStock.netStocks || []
                      )
                    ).sort((s1, s2) => s2.totalCost - s1.totalCost)}
                  ></StockTable>
                )}
            </div>
          </div>
        </Tab>
      </Tabs>

      <DailyReportScreenSave
        isUpdate={isUpdate}
        dailyReport={dailyReport}
        showDailySaveModal={showDailySaveModal}
        setShowDailySaveModal={setShowDailySaveModal}
      />
    </div>
  );
}
